import axiosInstance from "./AxiosInstance";

export function getActionTypeList(data) {
  return axiosInstance.post(`/action-type/list`, data);
}

export function createActionTYpe(data) {
  return axiosInstance.post(`/action-type/create`, data);
}

export function updateActionTYpe(data) {
  return axiosInstance.post(`/action-type/update`, data);
}
export function deleteActionTYpe(data) {
  return axiosInstance.post(`/action-type/delete`, data);
}

export function getSerachActionTypeList(data) {
  return axiosInstance.post(`/action-type-search-list`, data);
}
